import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ConfigProvider } from "../../config-provider.service";
import { TranslateService } from "@ngx-translate/core";
import { AppRoutingService } from "./app-routing-service";

@Injectable({
  providedIn: 'root'
})
export class TitleServiceProvider implements OnDestroy {

  public defaultTitle = '';
  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private title: Title,
    private routerService: AppRoutingService,
    private translator: TranslateService,
    private conf: ConfigProvider
  ) {
    this.defaultTitle = this.conf.platformName;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public boot(): void {
    this.subscriptions.push(
      this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          const title = this.routerService.getRouteTitle();
          return title ? `${this.defaultTitle} | ${this.translator.instant(title)}` : this.defaultTitle;
        }),
      ).subscribe((title: string) => {
        this.title.setTitle(title);
      })
    );
  }

  public setTitle(title: string): void {
    this.title.setTitle(title);
  }
}
